export default __webpack_public_path__ + "static/media/2482.08049858.svg";